"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMediaDto = void 0;
class UpdateMediaDto {
    mediaType;
    media;
    metadata;
    qr;
    admefy_tv;
    vrmefy;
    published;
    thumbnail;
    owner;
    allowed_users;
    title;
    description;
    fork_from;
    duration;
    emit_date;
    price;
}
exports.UpdateMediaDto = UpdateMediaDto;
